import styled from 'styled-components';
import { StyledDisplayPriceProps } from './DisplayPrice.types';

export const StyledDisplayPrice = styled.div<StyledDisplayPriceProps>`
  position: relative;

  .display-price__base-price {
    position: relative;
    white-space: nowrap;
    font-weight: ${(props) =>
      props.discounted || !props.alwaysBold ? 'normal' : 'bold'};
    &::before {
      position: absolute;
      display: ${(props) => (props.discounted ? 'block' : 'none')};
      content: '';
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      border-top: 2px solid #ea3729;
    }
  }

  .display-price__discounted-price {
    color: #ea3729;
    font-weight: bold;
    &::before {
      content: ' ';
    }
  }

  ${(props) => props.customStyle}
`;
